"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const toolkit_1 = require("@reduxjs/toolkit");
const react_i18next_1 = require("react-i18next");
const navContainer_1 = __importDefault(require("../../../components/navContainer/navContainer"));
const monoCard_1 = __importDefault(require("../../../components/monoCard/monoCard"));
const text_1 = __importStar(require("../../../components/text/text"));
const styles_1 = __importDefault(require("../../../styles/styles"));
const store_1 = require("../../../store");
const financialBankAccountSlice_1 = require("./financialBankAccountSlice");
const constants_1 = require("../../../constants/constants");
const analytics_1 = require("../../../utils/analytics/analytics");
const AddBankAccount = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [errors, setErrors] = (0, react_1.useState)();
    const [providers, setProviders] = (0, react_1.useState)([]);
    const getAllProviderAux = async () => {
        setIsLoading(true);
        const result = await dispatch((0, financialBankAccountSlice_1.getAllProviders)({}));
        logEventWithExtraProperties('api_call', {
            name: 'get_connect_bank_providers',
            status: 'submitted',
            location: 'screen_AddBankAccount',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'get_connect_bank_providers',
                status: 'success',
                location: 'screen_AddBankAccount',
            });
            setProviders(result.payload);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'get_connect_bank_providers',
                status: 'fail',
                location: 'screen_AddBankAccount',
            });
            setErrors(result.payload);
        }
        setIsLoading(false);
    };
    (0, react_1.useEffect)(() => {
        getAllProviderAux();
    }, []);
    return (react_1.default.createElement(navContainer_1.default, { isLoading: isLoading, errors: errors, childrenTitle: "Bank account information" },
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne] },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, t('bankAccountDetails.connect_bank_account'))),
            providers.map((provider) => (react_1.default.createElement(react_native_1.View, { key: provider },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically }, provider === constants_1.BANK_STATEMENT_PROVIDER_MONO && react_1.default.createElement(monoCard_1.default, null))))))));
};
exports.default = AddBankAccount;
